import pagesConfig from "./pagesConfig";
import Theme from "./theme";
import fonts from "./fonts";
import Colors from "./colors";
import SVG from "./svg";

const { spacing: Spacing } = Theme.Light;
export { pagesConfig, Theme, Spacing, fonts, Colors, SVG };
